<template>
    <div class="cancel">
        <div class="icon">
            <img src="@/assets/img/task-finish.svg">
        </div>
        <div class="info">
            任務已取消
        </div>
        <div class="list">
            <div class="item" v-if="price">
                <div class="content">
                    <div class="tick">
                        <img src="@/assets/img/tick.svg">
                    </div>
                    <div class="title">已收取</div>
                    <div class="description">任務取消費用</div>
                    <div class="price">${{ price }}</div>
                </div>
                <div class="tip"></div>
            </div>
            <div class="item" v-if="refund">
                <div class="content">
                    <div class="tick">
                        <img src="@/assets/img/tick.svg">
                    </div>
                    <div class="title">已退還</div>
                    <div class="description">您的預刷款項</div>
                    <div class="price">${{ refund }}</div>
                </div>
                <div class="tip">
                    將由您的發卡銀行處理退刷款項，您不需要負擔任何手續費
                </div>
            </div>
        </div>
        <div class="button" @click="back">我知道了</div>
    </div>
</template>

<script>
    import * as R from 'ramda';

    export default {
        name: "Cancel",
        data() {
            return {
                'price': 0,
                'prepaid': 0,
            }
        },
        computed: {
            refund() {
                return R.max(this.prepaid - this.price, 0);
            }
        },
        methods: {
            back() {
                if (window.history.length > 2) {
                    this.$router.go(-1);
                } else {
                    this.$router.push({
                        name: 'home',
                    });
                }
            }
        },
        created() {
            this.price = this.$route.params.price;
            this.prepaid = this.$route.params.prepaid;
        }
    }
</script>

<style lang="scss" scoped>
    .cancel {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .info {
            margin: 20px;
            font-size: 20px;
            color: #4a4a4a;
        }

        .list {
            width: 250px;
            .item {
                margin: 10px;

                .content {
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    font-size: 16px;

                    .tick {
                        width: 24px;
                        height: 24px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }

                    .title {
                        font-weight: 500;
                        color: #4a4a4a;
                    }

                    .description {
                        margin-left: 5px;
                        color: #4a4a4a;
                    }

                    .price {
                        margin-left: 5px;
                        color: #339933;
                    }
                }

                .tip {
                    text-align: left;
                    font-size: 14px;
                    color: #9b9b9b;
                    margin-left: 20px;
                }
            }
        }

        .button {
            margin-top: 45px;
            border-radius: 16px;
            background-color: #339933;
            color: #FFFFFF;
            font-size: 16px;
            padding: 5px 15px;
            cursor: pointer;
            user-select: none;
        }
    }
</style>